<div mobile (mobileView)="isMobileView = $event" class="articles-container row">
    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
        <div class="articles-left-content">
            <ng-template [ngIf]="!isMobileView">
            <h4>Articles in this section</h4>
            <ng-template
                ngFor
                let-interview
                [ngForOf]="interviewList"
            >
                <div
                    class="catalog-list-item catalog-list-item--clickable"
                    (click)="selectedInterviewId = interview.id"
                    [ngClass]="{
            'catalog-list-item--selected': selectedInterviewId == interview.id
          }"
                >
                    {{ interview?.title }}
                </div>
            </ng-template>
        </ng-template>
        <ng-template [ngIf]="isMobileView">
            <div class="form-group stretch">
              <mat-form-field>
                  <mat-select
                      disableOptionCentering
                      placeholder="Articles in this section"
                      [(ngModel)]="selectedInterviewId"
                      name="mediaArticle"
                      #mediaArticle="ngModel"
                      (selectionChange)="onSelectionChange($event)"
                  >
                      <mat-option
                          *ngFor="let interview of interviewList"
                          [value]="interview.id"
                      >
                      {{ interview?.title }}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
          </div>
          </ng-template>
        </div>
    </div>
    <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <div
            *ngIf="interviewMap[selectedInterviewId]"
            class="articles-right-content"
        >
            <h1>
                {{ interviewMap[selectedInterviewId]["title"] }}
            </h1>
            <div class="article-history align-h margin-top-35 margin-bottom-35">
                <div class="article-history-updated stretch">{{ interviewMap[selectedInterviewId]["translatedModifiedDate"] }} </div>
                <ng-template [ngIf]="!isMobileView">
                    <div class="article-history-sharing">
                      Share article to
                      <a
                        href="https://www.facebook.com/sharer/sharer.php?u={{ pageUrl }}"
                        target="_blank"
                      >
                        <img src="assets/svg/Facebook.svg" alt="facebook" />
                      </a>
                      <a href="https://twitter.com/share?url={{ pageUrl }}" target="_blank">
                        <img src="assets/svg/Twitter.svg" alt="twitter" />
                      </a>
                      <a
                        href="https://www.linkedin.com/shareArticle?url={{ pageUrl }}"
                        target="_blank"
                      >
                        <img src="assets/svg/LinkedIN.svg" alt="linkedin" />
                      </a>
                    </div>
                    <button
                    *ngIf="interviewMap[selectedInterviewId]['pdfUrl'] && !inProgress"
                      type="button"
                      class="btn btn-primary btn-lg pdf-button"
                      (click)="downloadAsPDF(interviewMap[selectedInterviewId]['pdfUrl'])"
                    >
                      <span class="article-history-pdf-download">
                        <img src="assets/svg/pdf-file.svg" alt="pdf" />
                      </span>
                      Download
                    </button>
                    <mat-spinner *ngIf="inProgress"  [diameter]="25"></mat-spinner>
                  </ng-template>
                 <ng-template [ngIf]="isMobileView">
                  <div class="article-history-sharing--mobile">
                    <a
                    href="https://www.facebook.com/sharer/sharer.php?u={{ pageUrl }}"
                    target="_blank">
                    <img src="assets/svg/Facebook.svg" alt="facebook" />
                  </a>
                  </div>
                <span *ngIf="interviewMap[selectedInterviewId]['pdfUrl'] && !inProgress" class="article-history-pdf-download--mobile" (click)="downloadAsPDF(interviewMap[selectedInterviewId]['pdfUrl'])">
                  <img src="assets/svg/pdf-file.svg" alt="pdf" />
                </span>
                <mat-spinner *ngIf="inProgress"  [diameter]="25"></mat-spinner>
                 </ng-template>
            </div>
            <div
                class="article-image"
                *ngIf="interviewMap[selectedInterviewId]['imagePath']"
            >
                <img
                    [src]="interviewMap[selectedInterviewId]['imagePath']"
                    [alt]="interviewMap[selectedInterviewId]['title']"
                >
            </div>
            <div
            class="article-image"
            *ngIf="interviewMap[selectedInterviewId]['video']"
        >
        <iframe class="article-vedio-iframe" [src]="getSafeUrl(interviewMap[selectedInterviewId]['video'])" frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
      </iframe>
        </div>
            <p
                class="article-html-content margin-top-35 margin-bottom-35"
                [innerHTML]="interviewMap[selectedInterviewId]['htmlContent']"
            ></p>
            <div class="button-black">
                <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    (click)="investOnline()"
                >
                    Invest Now
                </button>
            </div>
        </div>
    </div>
</div>
